import { useEffect, useState } from "react"
import { useLocation } from "@reach/router"
import { initializeAndTrack } from "gatsby-plugin-gdpr-cookies"
import { LinkField } from "../craft/linkField"
import { useCookie } from "../../hooks/useCookie"

function isBrowser() {
  return typeof window !== "undefined"
}

function getValue(key, defaultValue) {
  return isBrowser() && window.localStorage.getItem(key)
    ? JSON.parse(window.localStorage.getItem(key))
    : defaultValue
}

function setValue(key, value) {
  window.localStorage.setItem(key, JSON.stringify(value))
}

function useStickyState(defaultValue, key) {
  const [value, setter] = useState(() => {
    return getValue(key, defaultValue)
  })

  useEffect(() => {
    setValue(key, value)
  }, [key, value])

  return [value, setter]
}

export const CookieConsent = (cookieConsentBanner) => {
  const location = useLocation()
  if (isBrowser()) {
    initializeAndTrack(location)
  }

  const [bannerHidden, setBannerHidden] = useStickyState(
    false,
    "consentCookieHidden"
  )

  // get cookie
  const cookie = useCookie()

  const EnableAnalytics = () => {
    document.cookie = "gatsby-gdpr-google-analytics=true"
    document.cookie = "gatsby-autopilot-forms-analytics=true"
    setBannerHidden(true)
  }
  const DisableAnalytics = () => {
    window[`ga-disable-UA-58997388-1`] = true
    setBannerHidden(true)
  }

  return (
    <div>
      {!bannerHidden && (
        <div className="fixed bottom-0 right-0 z-40 m-4 bg-white shadow-xl md:w-1/3 xl:w-1/4">
          <div className="">
            <div className="relative p-12 overflow-hidden">
              <div
                width="80"
                height="77"
                className="absolute -top-10 -right-10 text-highlightColor"
              >
                <svg
                  width="120"
                  height="119"
                  viewBox="0 0 120 119"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="1"
                    d="M6.38128 49.1539C3.20326 32.893 13.809 17.1346 30.0699 13.9566L70.3846 6.07751C86.6455 2.89948 102.404 13.5052 105.582 29.7661L113.461 70.0808C116.639 86.3417 106.033 102.1 89.7724 105.278L49.4577 113.157C33.1968 116.335 17.4384 105.729 14.2604 89.4686L6.38128 49.1539Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <div className="flex flex-col m-4 text-xl">
                {cookie.excerpt && (
                  <div>
                    <small>{cookie.excerpt}</small>
                    <span>
                      <LinkField
                        className="pl-2 text-sm no-underline text-primary"
                        {...cookie.ctaLink}
                      />
                    </span>
                  </div>
                )}
              </div>
              <div className="flex flex-row gap-4 m-4">
                <button
                  type="submit"
                  className="px-4 py-2 text-xs border-2 rounded lg:text-sm text-pink border-pink hover:shadow-lg"
                  onClick={DisableAnalytics}
                >
                  Decline
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 text-xs text-white border-2 rounded lg:text-sm border-pink bg-pink hover:shadow-lg"
                  onClick={EnableAnalytics}
                >
                  Accept
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
